@for (reportQuestion of questionsAndAnswers; track reportQuestion) {
  <div
    [ngClass]="{'question-container' : reportQuestion.validateRules | hideFromReportDetailPipe}">
    @if (reportQuestion.validateRules | hideFromReportDetailPipe) {
      <span class="question">
        @if (reportQuestion.recurrence > 0) {
          <div class="recurrence-number">{{reportQuestion.recurrence}}.
          </div>
        }
        {{reportQuestion.question}}
      </span>
      @if (reportQuestion.answer.toLowerCase() !== 'question-group-answer') {
        <span class="answer"
        [ngClass]="{'question-group': reportQuestion.recurrence > 0}">{{ reportQuestion.answer }}</span>
      }
    }
    @if (isEmailsDataType(reportQuestion.validateRules)) {
      <span>
        <span class="question">{{reportQuestion.question}}</span>
        <div class="list-basic">
          @for (email of reportQuestion.answer.split(';'); track email) {
            <li>{{email}} </li>
          }
        </div>
      </span>
    }
    @if (reportQuestion.followupQuestions) {
      <div>
        <div class="question-group">
          <app-question-list [questionsAndAnswers]="reportQuestion.followupQuestions"></app-question-list>
        </div>
      </div>
    }
  </div>
}
